import { cn } from "@/lib/utils";
import { PrometheusMark } from "./PrometheusMark";

export const Logo = ({
  className,
  compact = false,
}: {
  className?: string;
  /** Smaller mark; subtitle only from sm up — for tight OS / mobile headers. */
  compact?: boolean;
}) => (
  <div className={cn("flex items-center", compact ? "gap-2" : "gap-2.5", className)}>
    <PrometheusMark
      animated
      className={cn("drop-shadow-[0_0_10px_rgba(249,115,22,0.45)]", compact ? "h-7 w-7 sm:h-8 sm:w-8" : "h-8 w-8")}
    />
    <div className="flex flex-col leading-none">
      <span
        className={cn(
          "font-serif-display font-semibold tracking-tight whitespace-nowrap",
          compact ? "text-[15px] sm:text-lg" : "text-lg"
        )}
      >
        Prometheus
      </span>
      <span
        className={cn(
          "font-mono-tech uppercase tracking-[0.3em] text-muted-foreground",
          compact ? "hidden text-[10px] sm:inline" : "text-[10px]"
        )}
      >
        Lab · AI
      </span>
    </div>
  </div>
);